import React from "react";
import "./BookingPopup.css";
import EmailTicket from "../EmailTicket";

function Popup({ Open, onClose, component }) {
  if (!Open) return null; // If Open is false, don't render the popup

  return (
    <div className="user-popup-overlay-booking" onClick={onClose}>
      <div
        className={`user-popup-content-booking`}
        onClick={(e) => e.stopPropagation()}
      >
        {component}
      </div>
    </div>
  );
}

export default Popup;
